import axios from "axios";

const BaseURL = window.BaseURL;
// const BaseURL = "http://192.168.1.19:3000";//local
// const BaseURL = "http://192.168.10.1:8081" //test
// const BaseURL = "http://192.168.1.12:3000"; //dev
// const BaseURL = "http://103.140.19.101:8080";//Prod

localStorage.setItem("BaseURL", BaseURL);
const TOKEN_PREFIX = "Bearer  ";

const axiosInstance = axios.create({
  BaseURL: BaseURL,
  timeout: 30000,
  headers: {
    Authorization: localStorage.getItem("access_token")
      ? TOKEN_PREFIX + localStorage.getItem("access_token")
      : null,
    "Content-Type": "application/json",
    accept: "application/json",
  },
});
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    const originalRequest = err.config;

    // If there's no response (network error, timeout, CORS issue, etc.),
    // err.response will be undefined. Guard against that to avoid
    // "Cannot read properties of undefined (reading 'status')" errors.
    if (!err.response) {
      console.error("Axios network/connection error:", err);
      return Promise.reject(err);
    }

    if (err.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return axiosInstance(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refreshToken = localStorage.getItem("refresh_token");

      if (refreshToken && refreshToken !== "undefined") {
        const tokenParts = JSON.parse(atob(refreshToken.split(".")[1]));

        // exp date in token is expressed in seconds, while now() returns milliseconds:
        const now = Math.ceil(Date.now() / 1000);

        if (tokenParts.exp > now) {
          return new Promise(function (resolve, reject) {
            axiosInstance
              .post(BaseURL + "/users/token/refresh/", {
                refresh: refreshToken,
              })
              .then((response) => {
                localStorage.setItem("access_token", response.data.access);

                axiosInstance.defaults.headers["Authorization"] =
                  TOKEN_PREFIX + response.data.access;
                originalRequest.headers["Authorization"] =
                  TOKEN_PREFIX + response.data.access;
                processQueue(null, response.data.access);
                resolve(axiosInstance(originalRequest));
              })
              .catch((err) => {
                processQueue(err, null);
                // store.dispatch(showMessage({ message: "Expired Token" }));

                reject(err);
              })
              .then(() => {
                isRefreshing = false;
              });
          });
        } else {
          window.location.href = "/login/";
        }
      } else {
        window.location.href = "/login/";
      }
    }

    return Promise.reject(err);
  }
);

// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const originalRequest = error.config;

//     // Prevent infinite loops early
//     if (
//       error.response.status === 401 &&
//       originalRequest.url === BaseURL + "users/token/refresh/"
//     ) {
//       window.location.href = "/login/";
//       return Promise.reject(error);
//     }

//     if (
//       error.response.data.code === "token_not_valid" &&
//       error.response.status === 401 &&
//       error.response.statusText === "Unauthorized"
//     ) {
//       const refreshToken = localStorage.getItem("refresh_token");
//

//       if (refreshToken && refreshToken !== "undefined") {
//         const tokenParts = JSON.parse(atob(refreshToken.split(".")[1]));
//
//         // exp date in token is expressed in seconds, while now() returns milliseconds:
//         const now = Math.ceil(Date.now() / 1000);
//

//         if (tokenParts.exp > now) {
//           return axiosInstance
//             .post("users/token/refresh/", { refresh: refreshToken })
//             .then((response) => {
//               localStorage.setItem("access_token", response.data.access);
//               localStorage.setItem("refresh_token", response.data.refresh);

//               axiosInstance.defaults.headers["Authorization"] =
//                 TOKEN_PREFIX + response.data.access;
//               originalRequest.headers["Authorization"] =
//                 TOKEN_PREFIX + response.data.access;

//               return axiosInstance(originalRequest);
//             })
//             .catch((err) => {
//
//             });
//         } else {
//
//           window.location.href = "/login/";
//         }
//       } else {
//
//         window.location.href = "/login/";
//       }
//     }

//     // specific error handling done elsewhere
//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
export { BaseURL, axiosInstance, TOKEN_PREFIX };
